import { render, staticRenderFns } from "./AdditionAndSubtraction.vue?vue&type=template&id=515342a3&scoped=true&lang=pug&"
import script from "./AdditionAndSubtraction.vue?vue&type=script&lang=js&"
export * from "./AdditionAndSubtraction.vue?vue&type=script&lang=js&"
import style0 from "./AdditionAndSubtraction.vue?vue&type=style&index=0&id=515342a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515342a3",
  null
  
)

export default component.exports